export default __webpack_public_path__ + "static/media/facebook.b8e35364.svg";